@if (open) {
  <div
    class="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/40 p-4"
    role="dialog"
    aria-modal="true"
    [attr.aria-label]="title"
    (click)="close()"
  >
    <div
      class="w-full max-w-sm rounded-md bg-white p-5 shadow-2xl"
      (click)="$event.stopPropagation()"
    >
      <div class="space-y-2">
        <h3 class="text-base font-semibold text-gray-900">{{ title }}</h3>
        <p class="text-sm text-gray-600">
          @if (messageHtml) {
            <span [innerHTML]="messageHtml"></span>
          } @else {
            {{ message }}
          }
        </p>
      </div>

      <div class="mt-5 flex justify-end gap-2">
        <button
          type="button"
          class="rounded-lg bg-slate-100 px-4 py-2 text-sm font-semibold text-slate-700 transition-colors hover:bg-slate-200 disabled:cursor-not-allowed disabled:opacity-70"
          (click)="close()"
          [disabled]="loading"
        >
          {{ cancelText }}
        </button>
        <button
          type="button"
          class="rounded-lg px-4 py-2 text-sm font-semibold text-white transition-colors disabled:cursor-not-allowed disabled:opacity-70"
          [ngClass]="
            confirmVariant === 'danger'
              ? 'bg-red-600 hover:bg-red-700'
              : 'bg-secondary hover:bg-indigo-700'
          "
          (click)="confirm()"
          [disabled]="loading"
        >
          {{ loading ? 'Working...' : confirmText }}
        </button>
      </div>
    </div>
  </div>
}
